export enum RTFVersion {
    // FB_OLD               = 1, // DraftJS rtf has no version
    DRAFT_JS                = 'draft-js',
    LEXICAL                 = 'lexical-1',
    // LEXICAL_1            = 'lexical-1',

    CLICKUP_IMPORT          = 'clickup_import',
    ASANA_IMPORT            = 'asana_import',

    WHITEBOARD_EXCALIDRAW   = 'excalidraw',

    MARKDOWN                = 'markdown'    // New. Used in AI chat messages

}


export type ContentRTF = {
    v                           : RTFVersion
    content?                    : any,
    importOriginal?             : string    // original content when import - we never change it !
    markdown                    : any,      // poka ne nado - potom nado !!!!
}
